import React, { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Grid,
  Switch,
  CircularProgress,
  useMediaQuery,
  useTheme,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import { LongBody, ShortBody } from 'components/Typography';
import {
  StyledPaper,
  ActiveNotificationWrapper,
} from 'containers/MyAccountPage/styles';
import CardHeader from 'containers/MyAccountPage/CardHeader';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'helpers/intl';
import messages from 'containers/MyAccountPage/messages';
import get from 'lodash/get';
import { getIsLoadingNotficationEnabled } from 'store/credentials/selectors';
import { enableNotifications } from 'store/credentials/actions';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { changeLocaleLanguage } from 'store/LanguageProvider/actions';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';

const MyPreferences = (props: MyPreferencesType) => {
  const { handleChange, values } = props;
  const isNotificationActionLoading = useSelector(
    getIsLoadingNotficationEnabled,
  );
  const lang = useSelector(getLocaleSelector);
  const dispatch = useDispatch();
  const handleIsNotificationsEnabled = (e: any) => {
    values.isNotifEnabled
      ? GATracking.event(
          EVENT_CATEGORIES.SETTINGS,
          EVENT_ACTION.CLICK,
          'Désactiver les notifications',
        )
      : GATracking.event(
          EVENT_CATEGORIES.SETTINGS,
          EVENT_ACTION.CLICK,
          'Activer les notifications',
        );

    handleChange(e, e.target.value);
    dispatch(
      enableNotifications({ notification_enabled: !values.isNotifEnabled }),
    );
  };
  const handleLanguageChange = (
    e: ChangeEvent<HTMLInputElement>,
    value: string,
  ) => {
    dispatch(changeLocaleLanguage(value));
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <>
      <CardHeader
        title={translate(get(messages, 'myPreferences'), props)}
        icon="settings"
      />
      <StyledPaper>
        <Box pt={4} px={3} pb={3}>
          <Box mb={1}>
            <LongBody>
              {translate(get(messages, 'notifications'), props)}
            </LongBody>
          </Box>
          <ActiveNotificationWrapper container justify="space-between">
            <Grid item xs={4} container alignContent="center">
              <ShortBody>
                {translate(get(messages, 'activateNotifications'), props)}
              </ShortBody>
            </Grid>
            <Grid item xs={matches ? 2 : 1}>
              {isNotificationActionLoading ? (
                <CircularProgress
                  color="inherit"
                  size={25}
                  style={{ marginLeft: '5px' }}
                />
              ) : (
                <Switch
                  onChange={handleIsNotificationsEnabled}
                  checked={values.isNotifEnabled}
                  value={values.isNotifEnabled}
                  name="isNotifEnabled"
                />
              )}
            </Grid>
          </ActiveNotificationWrapper>
          <LongBody>{translate(get(messages, 'languages'), props)}</LongBody>
          <RadioGroup
            aria-label="language"
            name="language"
            value={lang}
            onChange={handleLanguageChange}
          >
            <Grid container>
              <Grid item xs>
                <GaClickHOC category={EVENT_CATEGORIES.SETTINGS} label="Arabe">
                  <FormControlLabel
                    value={LANGUAGES.AR}
                    control={<Radio />}
                    label={translate(get(messages, 'arabic'), props)}
                  />
                </GaClickHOC>
              </Grid>
              <Grid item xs>
                <GaClickHOC
                  category={EVENT_CATEGORIES.SETTINGS}
                  label="Français"
                >
                  <FormControlLabel
                    value={LANGUAGES.FR}
                    control={<Radio />}
                    label={translate(get(messages, 'french'), props)}
                  />
                </GaClickHOC>
              </Grid>
            </Grid>
          </RadioGroup>
        </Box>
      </StyledPaper>
    </>
  );
};

export interface MyPreferencesType {
  intl: IntlShape;
  values: any;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
}

export default injectIntl(MyPreferences);
